if (!customElements.get('memorra-couple')) {
  customElements.define('memorra-couple', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.scope = this.closest('product-info') || this.closest('.shopify-section');
      this.form = this.querySelector('.mc-form');
      this.singleForm = this.querySelector('.mc-single-form');
      this.singlePanel = this.querySelector('.mc-single-panel');
      this.isCouplePage = this.dataset.currentGender === 'couple';
      this.panel = this.querySelector('.mc-panel');
      this.error = this.querySelector('.mc-error');
      this.purchase = this.querySelector('.mc-purchase');
      this.cartButton = this.querySelector('.mc-add');
      const box = this.closest('.memorra-design-box');
      if (box) box.after(this.purchase);
      const singleForm = this.scope.querySelector('product-form');
      if (singleForm) singleForm.after(this.cartButton);
      this.cartButton.hidden = this.dataset.currentGender !== 'couple';
      this.addEventListener('change', e => {
        if (e.target.matches('[name^="edition-"]')) this.setMode(e.target.value);
        if (e.target.matches('[data-member]')) this.setMode('single');
      });
      this.addEventListener('input', e => {
        if (!e.target.matches('[data-role]')) return;
        if(e.target.value.trim()){e.target.removeAttribute('aria-invalid');e.target.closest('.mc-field').querySelector('.EN-err').hidden=true;}
        this.updatePreview(e.target);
      });
      this.form.addEventListener('submit', e => this.submitPair(e));
      this.singleForm?.addEventListener('submit', e => this.submitPair(e));
      const params = new URLSearchParams(window.location.search);
      const requestedGender = params.get('gender');
      const requestedMember = this.querySelector('[data-member][value="' + (requestedGender === 'women' ? 'women' : 'men') + '"]');
      if (requestedMember) requestedMember.checked = true;
      const initialMode = params.get('edition') === 'single' ? 'single' : params.get('edition') === 'couple' ? 'couple' : this.isCouplePage ? 'couple' : 'single';
      const choice = this.querySelector('[name^="edition-"][value="' + initialMode + '"]');
      if (choice) choice.checked = true;
      this.setMode(initialMode);
    }
    updatePreview(input) {
      const field = input.closest('.mc-field');
      field.querySelector('.mc-preview').textContent = input.value || 'Your name';
      field.querySelector('.mc-count').textContent = input.value.length + '/10';
    }
    setMode(mode) {
      const couple = mode === 'couple';
      const localSingle = this.isCouplePage && !couple;
      const member = this.querySelector('[data-member]:checked');
      this.panel.hidden = !couple;
      if (this.singlePanel) this.singlePanel.hidden = !localSingle;
      this.purchase.hidden = !couple && !localSingle;
      this.cartButton.hidden = !couple && !localSingle;
      this.activeForm = localSingle ? this.singleForm : this.form;
      this.activeVariant = localSingle ? member.dataset.variant : this.dataset.variant;
      this.activePrice = localSingle ? member.dataset.price : this.dataset.price;
      this.activeTitle = localSingle ? member.dataset.title : this.dataset.title;
      this.activeAvailable = localSingle ? member.dataset.available === 'true' : this.dataset.available === 'true';
      const money = cents => new Intl.NumberFormat('en-IN', {style:'currency', currency:this.dataset.currency}).format(Number(cents)/100);
      const price = this.scope.querySelector('.custom-main-price');
      if (price) {
        if (!this.singlePrice) this.singlePrice = price.textContent;
        price.textContent = couple || localSingle ? money(this.activePrice) : this.singlePrice;
      }
      if (localSingle) this.singleForm.querySelector('[name="id"]').value = this.activeVariant;
      this.purchase.querySelectorAll('button').forEach(button => {
        button.setAttribute('form', this.activeForm.getAttribute('id'));
        button.disabled = !this.activeAvailable;
      });
      this.cartButton.setAttribute('form', this.activeForm.getAttribute('id'));
      this.cartButton.disabled = !this.activeAvailable;
      this.cartButton.textContent = this.activeAvailable ? (couple ? 'Add both to cart' : 'Add to cart') : 'Sold out';
      this.purchase.querySelectorAll('[data-couple-row]').forEach(row => row.hidden = !couple);
      const singleRow = this.purchase.querySelector('[data-single-row]');
      singleRow.hidden = !localSingle;
      if (localSingle) {
        singleRow.querySelector('[data-single-title]').textContent = this.activeTitle;
        singleRow.querySelector('[data-single-price]').textContent = money(this.activePrice);
      }
      this.purchase.querySelector('[data-total]').textContent = money(this.activePrice);
      this.scope.querySelectorAll('.custom-compare-price').forEach(el => el.classList.toggle('mc-single-hidden', couple || localSingle));
      const selectors = 'memorra-personalizer, memorra-checkout, #breeze-hidden-injection-site, product-form, .product-form__quantity, .everlasting-checkout-section';
      this.scope.querySelectorAll(selectors).forEach(el => {
        if (!this.contains(el)) el.classList.toggle('mc-single-hidden', couple || localSingle);
      });
      this.dataset.mode = mode;
      this.dataset.activeTitle = this.activeTitle;
      this.dataset.activePrice = this.activePrice;
      this.dataset.activeImage = localSingle ? member.dataset.image : '';
      const reassurance = this.purchase.querySelector('.custom-checkout-subtext');
      if (reassurance) reassurance.textContent = '✓ Free Shipping ✓ ' + this.activeTitle + ' ✓ Returns: eligibility applies';
      if (this.isCouplePage) this.scope.querySelectorAll('.custom-inventory-alert').forEach(el => el.classList.toggle('mc-single-hidden',localSingle));
      this.scope.querySelectorAll('.memorra-colour').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('edition', mode);
        if (localSingle) url.searchParams.set('gender', member.value);
        else url.searchParams.delete('gender');
        const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        link.href = url.pathname + url.search;
      });
      document.dispatchEvent(new CustomEvent('memorra:edition-change'));
      if (couple) {
        const single = this.isCouplePage ? this.singleForm.querySelector('[data-role="single"]') : this.scope.querySelector('memorra-personalizer .EN-inp');
        const role = this.isCouplePage ? member.value : this.dataset.currentGender;
        const corresponding = this.form.querySelector('[data-role="' + role + '"]');
        if (single?.value && corresponding && !corresponding.value) {
          corresponding.value = single.value;
          this.updatePreview(corresponding);
        }
      }
    }
    async submitPair(event) {
      event.preventDefault();
      if (this.busy) return;
      const form = this.activeForm;
      for (const field of form.querySelectorAll('[data-role]')) {
        field.value = field.value.trim();
        this.updatePreview(field);
        field.setAttribute('aria-invalid', String(!field.value));
        field.closest('.mc-field').querySelector('.EN-err').hidden = Boolean(field.value);
      }
      const invalid = form.querySelector('[aria-invalid="true"]');
      if (invalid) {invalid.scrollIntoView({block:'center',behavior:'smooth'});invalid.focus({preventScroll:true});return;}
      this.error.hidden = true;
      const intent = event.submitter?.value || 'cart';
      if (!this.activeAvailable) return;
      const buttons = [...this.purchase.querySelectorAll('button'), this.cartButton];
      const active = event.submitter;
      const original = active?.textContent;
      this.busy = true;
      buttons.forEach(b => { b.disabled = true; });
      if (active) active.textContent = 'Adding…';
      form.setAttribute('aria-busy', 'true');
      try {
        const data = new FormData(form);
        const properties = {};
        for (const [key, value] of data) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        const payload = { items: [{ id: Number(this.activeVariant), quantity: 1, properties }] };
        const fingerprint = JSON.stringify(payload.items);
        if (this.pendingHandoff !== fingerprint) {
          const response = await fetch(this.dataset.add, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(payload)
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || 'This item could not be added. Please try again.');
          this.pendingHandoff = fingerprint;
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'memorra-couple', productVariantId: this.activeVariant, cartData: result });
          }
        }
        if (intent === 'checkout') await window.memorraCommerce.checkout(event);
        else await window.memorraCommerce.openCart();
        this.pendingHandoff = null;
      } catch (error) {
        this.error.textContent = error.message || 'Please try again.';
        this.error.hidden = false;
      } finally {
        this.busy = false;
        buttons.forEach(b => { b.disabled = false; });
        if (active) active.textContent = original;
        form.removeAttribute('aria-busy');
        this.setMode(this.dataset.mode);
      }
    }
  });
}

